import { useLocation } from 'client/router/useLocation';
import useGlobalConfig from 'client/state/GlobalConfig';
import { getFullUrlPath } from 'client/utils/utils';
import { useMemo } from 'react';

export const useSEOBaseURL = () => {
  const { envURL } = useGlobalConfig();
  const location = useLocation();

  return useMemo(
    () => getFullUrlPath(`${location.pathname}${location.search}`, envURL),
    [envURL, location.pathname, location.search],
  );
};
